import request from '@/utils/request'

//企业列表分页查询
export function getCilent(data) {
  return request({
    url: '/Cilent/getCilentConditionPage',
    method: 'post',
    data
  })
}

//新增修改
export function insertCilent(data) {
  return request({
    url: '/Cilent/insertCilent',
    method: 'post',
    data
  })
}

// 删除
export function deleteCilent(data) {
  return request({
    url: '/Cilent/deleteCilentByCode',
    method: 'delete',
    params: data
  })
}

// 单个查询
export function getCilentConditionByid(data) {
  return request({
    url: '/Cilent/getCilentConditionByid',
    method: 'get',
    params: data
  })
}
